import { all, put, select, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import log from 'loglevel'

import config from '@config'

import { changeBlockLevel as deleteLevel } from '../../../../components/Workspace/components/HocBlock/components/BlockTitle/components/LevelPicker/actions'
import {
    toggleButtonsArrayButton,
    changebuttonsArrayButton,
} from '../../../../components/Ribbon/components/ButtonsArray/components/ConnectButton/actions'
import { RIBBON_ON_CHANGE_EVENT } from '../../../../components/Ribbon/components/HocOnChange/constants'
import { activeItem } from '../../../../components/Ribbon/components/DropDown/actions'
import { TABS_TAB_ACTIVATED } from '../../../../components/Tabs/constants'
import { postAppState } from '../../../../../../services/appState/actions'

import {
    reportTypeBlocksSelector,
    reportTypeToSelectSelector,
    blocksToToggleByActiveReport,
    getActiveReportId,
    getActiveReportBlocksForDelete,
    getActiveReportBlocks,
} from './selectors'
import { DROPDOWN_KEY, BUTTONSARRAY_KEY, BUTTONS_CONTROLS_KEY } from './constants'
import { reportRibbonOnChange } from './actions'

const MODULE_KEY = config.modules.report.key

function* onChangeReportRibbonSaga(_action) {
    const { module, component, item } = _.get(_action, 'data', {})

    if (module === MODULE_KEY) {
        switch (component) {
            case DROPDOWN_KEY: {
                const blocksToToggle = yield select(reportTypeBlocksSelector, item)

                const togglesActions = blocksToToggle
                    .map((block) => put(toggleButtonsArrayButton(MODULE_KEY, BUTTONSARRAY_KEY, block)))
                    .toJS()
                yield all(togglesActions)

                const reportId = yield select(getActiveReportId)
                if (reportId) {
                    const blocksToDelete = yield select(getActiveReportBlocksForDelete, reportId)

                    const deleteActions = blocksToDelete
                        .map((block) => put(deleteLevel(MODULE_KEY, reportId, block, null)))
                        .toJS()
                    yield all(deleteActions)
                }

                yield put(postAppState())

                break
            }
            case BUTTONS_CONTROLS_KEY: {
                const reportBlocks = yield select(getActiveReportBlocks)
                const blocksToChange = reportBlocks
                    .filter((block) => !block.get('isDisabled'))
                    .filter((block) => block.get('name') !== config.modules.report.blocks.bisnodeCertificates.key) // Ignore bisnode certificates - always active
                    .keySeq()
                    .toList()
                const active = item // _action.data.item: Boolean, true - shows all blocks, false - hides all blocks

                const changeActions = blocksToChange
                    .map((block) => put(changebuttonsArrayButton(MODULE_KEY, BUTTONSARRAY_KEY, block, active)))
                    .toJS()

                yield all(changeActions)
                yield put(postAppState())

                break
            }
            case BUTTONSARRAY_KEY: {
                // Nothing to do (nothing in ribbon is affected by ButtonsArray change event)
                break
            }
            default:
                log.info(`Wrong ribbon component key: ${component}`)
        }

        // no async actions before => dispatch last
        yield put(reportRibbonOnChange())
    }
}

function* onTabActiveSaga(_action) {
    const tabType = _.get(_action, 'data.type', null)
    if (tabType !== MODULE_KEY) return null

    const reportId = _.get(_action, 'data.id', null)

    // setting for buttons array component
    const blocksToToggle = yield select(blocksToToggleByActiveReport, reportId)
    // create all toggles actions
    const togglesActions = blocksToToggle
        .map((block) => put(toggleButtonsArrayButton(MODULE_KEY, BUTTONSARRAY_KEY, block)))
        .toJS()
    // dispatch all toggles actions
    yield all(togglesActions)

    // setting for dropdown component
    const reportTypeToSelect = yield select(reportTypeToSelectSelector, reportId)
    if (reportTypeToSelect) yield put(activeItem(MODULE_KEY, DROPDOWN_KEY, reportTypeToSelect))

    return null
}

export default function* reportRibbonSaga() {
    yield all([
        takeEvery(RIBBON_ON_CHANGE_EVENT, onChangeReportRibbonSaga),
        takeEvery(TABS_TAB_ACTIVATED, onTabActiveSaga),
    ])
}
